<template>
  <!-- <app-header /> -->
  <main class="container">
    <router-view />
  </main>
  <!-- <app-footer /> -->
</template>
